import dynamic from "next/dynamic";

import useStyles from "./styles.js";

const EmojiPicker = dynamic ( () => {
	return import ( "emoji-picker-react" );
}, { ssr: false }
);

const component = props => {
	const { darkMode, handleEmojiSelect } = props;
	const theming                         = darkMode ? "dark" : "light";
	const { classes }                     = useStyles ( undefined, { name: "styles" } );

	/*
	* Please refer to
		https://emojipedia.org/windows-emoji-support/
		and
		https://emojipedia.org/mac-emoji-support/
		for supporting emojiVersion
	*/

	return (
		<div className = { classes.rootCtn }>
			<EmojiPicker
				autoFocusSearch     = { false }
				emojiVersion        = "10.0"
				height              = { 210 }
				lazyLoadEmojis      = { true }
				onEmojiClick        = { handleEmojiSelect }
				searchDisabled      = { true }
				skinTonesDisabled   = { true }
				suggestedEmojisMode = { "frequent" }
				theme               = { theming }
				width               = "100%"
			/>
		</div>
	);
};

export default component;
